import React from 'react';
import './loader.css';

export default function Loader() {
  return (
    <div className="lds-default">{[...Array(12).keys()].map(key => <div key={key} />)}</div>
  );
}
